import { render, staticRenderFns } from "./BankersList.vue?vue&type=template&id=21110382"
import script from "./BankersList.vue?vue&type=script&lang=js"
export * from "./BankersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports